import { BackOfficePermissions, PermissionGroup, PermissionsDetails } from '../user-group/model/UserGroupDetails';
import { UserFunctionLink } from '../user-group/model/UserFunction';

export const permissionGroupList: PermissionGroup[] = [];

export const shopFloorPermissions: PermissionsDetails[] = [
  {
    id: 0,
    leftSideLabel: 'enableText',
    leftSideLabelKey: '',
    isCheckedLeftBox: false,
    rightSideLabel: 'enableText',
    rightSideLabelKey: '',
    isCheckedRightBox: false
  },
  {
    id: 1,
    leftSideLabel: 'initialInspectionText',
    leftSideLabelKey: 'INITIAL_INSPECTION_EDIT',
    isCheckedLeftBox: false,
    rightSideLabel: 'bufferText',
    rightSideLabelKey: 'BUFFER_EDIT',
    isCheckedRightBox: false
  },
  {
    id: 2,
    leftSideLabel: 'ciaText',
    leftSideLabelKey: 'CIA_EDIT',
    isCheckedLeftBox: false,
    rightSideLabel: 'skiveText',
    rightSideLabelKey: 'SKIVE_EDIT',
    isCheckedRightBox: false
  },
  {
    id: 3,
    leftSideLabel: 'cementFillText',
    leftSideLabelKey: 'CEMENT_FILL_EDIT',
    isCheckedLeftBox: false,
    rightSideLabel: 'repairText',
    rightSideLabelKey: 'REPAIRS_EDIT',
    isCheckedRightBox: false
  },
  {
    id: 4,
    leftSideLabel: 'treadPreparationText',
    leftSideLabelKey: 'TREAD_PREPARATION_EDIT',
    isCheckedLeftBox: false,
    rightSideLabel: 'builderText',
    rightSideLabelKey: 'BUILDER_EDIT',
    isCheckedRightBox: false
  },
  {
    id: 5,
    leftSideLabel: 'chamberText',
    leftSideLabelKey: 'CURING_EDIT',
    isCheckedLeftBox: false,
    rightSideLabel: 'finalInspectionText',
    rightSideLabelKey: 'FINAL_INSPECTION_EDIT',
    isCheckedRightBox: false
  },
  {
    id: 6,
    leftSideLabel: 'servicesText',
    leftSideLabelKey: 'SERVICES_EDIT',
    isCheckedLeftBox: false,
    rightSideLabel: 'shippingText',
    rightSideLabelKey: 'SHIPPING_EDIT',
    isCheckedRightBox: false
  },
  {
    id: 7,
    leftSideLabel: 'receivingText',
    leftSideLabelKey: 'RECEIVING_VIEW',
    isCheckedLeftBox: false,
    rightSideLabel: 'actionRejectText',
    rightSideLabelKey: 'REJECT_EDIT',
    isCheckedRightBox: false
  },
  {
    id: 8,
    leftSideLabel: 'adjustmentText',
    leftSideLabelKey: 'WARRANTY_EDIT',
    isCheckedLeftBox: false,
    rightSideLabel: 'casingText',
    rightSideLabelKey: 'CASING_EDIT_EDIT',
    isCheckedRightBox: false
  },
  {
    id: 9,
    leftSideLabel: 'sidewallRenewalText',
    leftSideLabelKey: 'SIDEWALL_EDIT',
    isCheckedLeftBox: false,
    rightSideLabel: '',
    rightSideLabelKey: '',
    isCheckedRightBox: false
  }
];

export const generalPermissions: PermissionsDetails[] = [
  {
    id: 0,
    leftSideLabel: 'enableText',
    leftSideLabelKey: '',
    isCheckedLeftBox: false,
    rightSideLabel: 'enableText',
    rightSideLabelKey: '',
    isCheckedRightBox: false
  },
  {
    id: 1,
    leftSideLabel: 'rerunReworkText',
    leftSideLabelKey: 'RERUN_REWORK',
    isCheckedLeftBox: false,
    rightSideLabel: 'rejectCasingText',
    rightSideLabelKey: 'REJECT_CASING',
    isCheckedRightBox: false
  },
  {
    id: 2,
    leftSideLabel: 'deleteCasingsText',
    leftSideLabelKey: 'DELETE_CASINGS',
    isCheckedLeftBox: false,
    rightSideLabel: 'unrejectText',
    rightSideLabelKey: 'UNREJECT',
    isCheckedRightBox: false
  },
  {
    id: 3,
    leftSideLabel: 'recallCasingsToFinalText',
    leftSideLabelKey: 'RECALL_CASINGS',
    isCheckedLeftBox: false,
    rightSideLabel: 'searchButtonText',
    rightSideLabelKey: 'SEARCH',
    isCheckedRightBox: false
  },
  {
    id: 4,
    leftSideLabel: 'workflowBringBackwardText',
    leftSideLabelKey: 'WORK_FLOW_BRING_BACKWARD',
    isCheckedLeftBox: false,
    rightSideLabel: 'workflowBringForwardText',
    rightSideLabelKey: 'WORK_FLOW_BRING_FORWARD',
    isCheckedRightBox: false
  },
  {
    id: 5,
    leftSideLabel: 'printLabelsText',
    leftSideLabelKey: 'PRINT_LABELS',
    isCheckedLeftBox: false,
    rightSideLabel: 'printReportsText',
    rightSideLabelKey: 'PRINT_REPORTS',
    isCheckedRightBox: false
  },
  {
    id: 6,
    leftSideLabel: 'changeProcessCodeText',
    leftSideLabelKey: 'CHANGE_PROCESS_CODE',
    isCheckedLeftBox: false,
    rightSideLabel: 'allowMultipleDeleteText',
    rightSideLabelKey: 'ALLOW_MULTIPLE_DELETE',
    isCheckedRightBox: false
  },
  {
    id: 7,
    leftSideLabel: 'manageEmailsText',
    leftSideLabelKey: 'MANAGE_EMAILS',
    isCheckedLeftBox: false,
    rightSideLabel: 'unlockCasingText',
    rightSideLabelKey: 'UNLOCK_CASING',
    isCheckedRightBox: false
  },
  {
    id: 8,
    leftSideLabel: 'viewAuditTrailErrorLogText',
    leftSideLabelKey: 'VIEW_LOG',
    isCheckedLeftBox: false,
    rightSideLabel: 'inventoryAccessText',
    rightSideLabelKey: 'INVENTORY_ACCESS',
    isCheckedRightBox: false
  },
  {
    id: 9,
    leftSideLabel: 'ignoreCAMSpecsText',
    leftSideLabelKey: 'IGNORE_FLEET_SPECS',
    isCheckedLeftBox: false,
    rightSideLabel: 'rfidAdminText',
    rightSideLabelKey: 'RFID_ADMIN',
    isCheckedRightBox: false
  },
  {
    id: 10,
    leftSideLabel: 'rfidInstallationText',
    leftSideLabelKey: 'RFID_INSTALLATION',
    isCheckedLeftBox: false,
    rightSideLabel: 'rfidQuickScanText',
    rightSideLabelKey: 'RFID_QUICK_SCAN',
    isCheckedRightBox: false
  }
];

export const backOfficePermissions: BackOfficePermissions[] = [
  { id: 0, leftSideLabel: '', leftSideLabelKey: '', isAllChecked: true, isViewChecked: true, isEditChecked: true, isCreateChecked: true },
  {
    id: 1,
    leftSideLabel: 'workOrderText',
    leftSideLabelKey: 'WORK_ORDER',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'WORK_ORDER_VIEW',
    editKey: 'WORK_ORDER_EDIT',
    createKey: 'WORK_ORDER_CREATE'
  },
  {
    id: 2,
    leftSideLabel: 'posInterfacesText',
    leftSideLabelKey: 'POS',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'VIEW_POS_INTERFACES',
    editKey: 'EDIT_POS_INTERFACES'
  },
  {
    id: 3,
    leftSideLabel: 'camSpecificationsText',
    leftSideLabelKey: 'SETUP_FLEET_SPECIFICATIONS',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'SETUP_FLEET_SPECIFICATIONS_VIEW',
    editKey: 'SETUP_FLEET_SPECIFICATIONS_EDIT'
  },
  {
    id: 4,
    leftSideLabel: 'userSetupText',
    leftSideLabelKey: 'USER_SETUP',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'USER_SETUP_VIEW',
    editKey: 'USER_SETUP_EDIT'
  },
  {
    id: 5,
    leftSideLabel: 'userGroupSetupText',
    leftSideLabelKey: 'PROFILE_SETUP',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'PROFILE_SETUP'
  },
  {
    id: 6,
    leftSideLabel: 'plantSetupText',
    leftSideLabelKey: 'PLANT_SETUP',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'PLANT_SETUP_INFO_VIEW',
    editKey: 'PLANT_SETUP_INFO_EDIT'
  },
  {
    id: 7,
    leftSideLabel: 'siteSetupText',
    leftSideLabelKey: 'SITE_SETUP',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'SITE_SETUP_INFO_VIEW',
    editKey: 'SITE_SETUP_INFO_EDIT'
  },
  {
    id: 8,
    leftSideLabel: 'productSetupText',
    leftSideLabelKey: 'PRODUCT_SETUP',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'PRODUCT_SETUP_VIEW',
    editKey: 'PRODUCT_SETUP_EDIT'
  },
  {
    id: 9,
    leftSideLabel: 'customerSetupText',
    leftSideLabelKey: 'CUSTOMER',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'CUSTOMER_SETUP_VIEW',
    editKey: 'CUSTOMER_SETUP_EDIT',
    createKey: 'CREATE_CUSTOMERS'
  },
  {
    id: 10,
    leftSideLabel: 'setupServicesText',
    leftSideLabelKey: 'SETUP_SERVICES',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'SETUP_SERVICES_VIEW',
    editKey: 'SETUP_SERVICES_EDIT'
  },
  {
    id: 11,
    leftSideLabel: 'setupCasingGradingText',
    leftSideLabelKey: 'SETUP_CASING_GRADE',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'SETUP_CASING_GRADE_VIEW',
    editKey: 'SETUP_CASING_GRADE_EDIT'
  },
  {
    id: 12,
    leftSideLabel: 'notificationHubText',
    leftSideLabelKey: 'NOTIFICATION_HUB',
    isAllChecked: false,
    isViewChecked: false,
    isEditChecked: false,
    isCreateChecked: false,
    viewKey: 'NOTIFICATION_HUB_VIEW',
    editKey: 'NOTIFICATION_HUB_EDIT'
  }
];

export const functionList: UserFunctionLink[] = [];
